import { render, staticRenderFns } from "./FundTable-PositionsEtf.vue?vue&type=template&id=fba0d2d8&scoped=true&"
import script from "./FundTable-PositionsEtf.vue?vue&type=script&lang=js&"
export * from "./FundTable-PositionsEtf.vue?vue&type=script&lang=js&"
import style0 from "./FundTable-PositionsEtf.vue?vue&type=style&index=0&id=fba0d2d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba0d2d8",
  null
  
)

export default component.exports